import styled, { keyframes } from "styled-components";

export const Container = styled.div`
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgb(0, 0, 0, 0.5);
  z-index: 999999;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: scroll;
`;

const fadeInDown = keyframes`
    0% {
      opacity: 0;
      transform: translateY(-50px);
    }
    100% {
      opacity: 1;
      transform: translateY(0);
    }
`;

export const ModalWrapper = styled.div`
  width: 100%;
  max-width: 1050px;
  border-radius: 5px;
  height: auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: fixed;
  animation-name: ${fadeInDown} 0.8s;
  animation-duration: 0.8s;

`;

export const CloseButton = styled.button``;